import { selector } from 'recoil'

import { pageState } from './page'
import { calendarState } from './calendar'

export const singleListFilterState = selector({
  key: 'scheduledSendingsSingleListFilterState',
  get: ({ get }) => {
    const { allLists } = get(pageState)
    const { lists } = get(calendarState)

    return allLists.find(({ value }) => value === lists[0])
  }
})
